/**
 * Crea y exporta una constante equivalente al EnumFormaInventario del DAL
 */
export const EnumFormaInventario = {

  INVENTARIO: {codigoEstado: 1, nombre: "Importación Estándar"},
  IMPORTACION: {codigoEstado: 2, nombre: "Importación Limitada"},
  MIXTO: {codigoEstado: 3, nombre: "Mixto"},
}